export const expenseStatusTypeConstants = [
  { name: "Due", value: false },
  { name: "Paid", value: true },
];
